import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import {
  ZipPayslipUploadInitRequest,
  ZipPayslipUploadInitResponse,
} from "../request/ZipPayslipUploadRequest";

const RequestZipPayslipUploadApiService = async (
  request: ZipPayslipUploadInitRequest
): Promise<ZipPayslipUploadInitResponse> => {
  const { data } = await axios.post<ZipPayslipUploadInitResponse>(
    "/v1/employer/payslip-batches/",
    request
  );
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useRequestZipPayslipUploadApiService = () =>
  useMutation<
    ZipPayslipUploadInitResponse,
    AxiosError,
    ZipPayslipUploadInitRequest
  >(RequestZipPayslipUploadApiService, {
    mutationKey: ["RequestZipPayslipUploadApiService"],
  });

export default useRequestZipPayslipUploadApiService;
